import React from "react";

class Organizers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Organisers - 21st International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Organisers</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    {/* <div className="col-xl-6 col-md-6">
                      <h4>Honorary Chair</h4>
                      <img
                        src={require("../assets/img-comm/jason.png")}
                        alt=""
                        width="260"
                        height="280"
                      />
                      <p className="organiser_intro mt-2">
                        <b>Dr Jason Williams</b>
                        <br />
                        Deputy Dean of School of Technologies,
                        <br />
                        Cardiff Metropolitan University, UK
                      </p>
                    </div> */}
                    <div className="col-xl-12 col-md-12">
                      <h4>Honorary Chair</h4>
                      <img
                        src={require("../assets/img-comm/alvaro.jpg")}
                        alt="Prof. Alvaro Rocha"
                        width="260"
                        height="280"
                      />
                      <p className="organiser_intro mt-2">
                        <b>Prof. Álvaro Rocha</b>
                        <br /> Professor, University of Lisbon, Portugal
                        <br />
                        Vice-Chair of IEEE SMC Portugal Section Society Chapter
                      </p>
                    </div>
                  </div>
                  <div className="row speakers_row">
                    <div className="col-xl-6 col-md-6">
                      <h4>General Chair</h4>
                      <img
                        src={require("../assets/img-comm/abrar1.jpg")}
                        alt=""
                        width="240"
                        height="300"
                      />
                      <p className="organiser_intro  mt-2">
                        <b>Dr Abrar Ullah</b>
                        <br /> Associate Professor, Heriot-Watt University,
                        Edinburgh|<b>Dubai</b>|Malaysia
                      </p>
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <h4>General Chair</h4>
                      <img
                        src={require("../assets/img-comm/David_tien1.jpg")}
                        alt=""
                        width="260"
                        height="280"
                      />
                      <p className="organiser_intro mt-2">
                        <b>Dr David Tien</b>
                        <br />
                        IEEE Computer Society Asia-Pacific Area Coordinator
                        <br />
                        Charles Sturt University Australia
                      </p>
                    </div>
                  </div>
                  <div className="row speakers_row">
                    <div className="col-xl-4 col-md-4">
                      <h4>General Co-Chair</h4>
                      <img
                        src={require("../assets/img-comm/sajid.png")}
                        alt=""
                      />{" "}
                      <p className="organiser_intro  mt-2">
                        <b>Prof. Sajid Anwar</b>
                        <br /> Professor, Institute of Management Sciences,
                        Peshawar
                      </p>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <h4>General Co-chair</h4>
                      <img
                        src={require("../assets/img-comm/adrian.jpg")}
                        alt="Dr Adrian Turcanu"
                        width="200"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Adrian Turcanu</b>
                        <br /> Assistant Professor, Heriot-Watt University,
                        Edinburgh|<b>Dubai</b>|Malaysia
                      </p>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <h4>General Co-chair</h4>
                      <img
                        src={require("../assets/img-comm/fernando_new.PNG")}
                        alt=""
                        width="200"
                        height="270"
                      />
                      <p className="organiser_intro mt-2">
                        <b>Prof. Fernando Moreira</b>
                        <br /> Full Professor, Department of Science and
                        Technolgy, Portucalense University, Porto, Portugal
                      </p>
                    </div>
                  </div>
                  <div className="row speakers_row">
                    {/* <div className="col-xl-3 col-md-3">
                      <h4>International Chair</h4>
                      <img
                        src={require("../assets/img-comm/blank.png")}
                        alt=""
                      />{" "}
                      <p className="organiser_intro  mt-2">
                        <b>TBC</b>
                        <br />
                        TBC <br />
                        TBC{" "}
                      </p>
                    </div> */}

                    <div className="col-xl-4 col-md-4">
                      <h4>International Chair</h4>
                      <img
                        src={require("../assets/img-comm/maria2.png")}
                        alt="Dr. "
                        width="200"
                        height="280"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Maria José Sousa</b>
                        <br /> Professor and Senior Researcher at ISCTE –
                        University Institute of Lisbon, Portugal
                      </p>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <h4>International Chair</h4>
                      <img
                        src={require("../assets/img-comm/viola.png")}
                        alt="Dr Violo Ruhse"
                        width="220"
                        height="320"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Viola Rühse</b>
                        <br />
                        Senior Researcher, University for Continuing Education
                        Krems, Austria
                      </p>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <h4>International Chair</h4>
                      <img
                        src={require("../assets/img-comm/pimm.jpg")}
                        alt="Dr Pimmanee Rattanawicha"
                        width="220"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Pimmanee Rattanawicha</b>
                        <br />
                        Chulalongkorn University Thailand
                      </p>
                    </div>
                  </div>
                  <div className="row speakers_row">
                    {/* <div className="col-xl-4 col-md-4">
                      <h4>Workshop Chair</h4>
                      <img
                        src={require("../assets/img-comm/teresa.jpg")}
                        alt="Dr Teresa Guarda"
                        width="230"
                        height="240"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Teresa Guarda</b>
                        <br />
                        UDIMA - Distance University of Madrid, Spain{" "}
                      </p>
                    </div> */}
                    <div className="col-xl-6 col-md-6">
                      <h4>Workshop Chair</h4>
                      <img
                        src={require("../assets/img-comm/fawaz.png")}
                        alt="Dr Fawaz Khaled Alarfaj"
                        width="200"
                        height="280"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Fawaz Khaled Alarfaj</b>
                        <br />
                        King Faisal University, Saudi Arabia
                      </p>
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <h4>Workshop Chair</h4>
                      <img
                        src={require("../assets/img-comm/tim.png")}
                        alt="Dr Tim Lynar"
                        width="200"
                        height="250"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Tim Lynar</b>
                        <br />
                        Senior Lecturer, UNSW, Canberra, Australia
                      </p>
                    </div>
                  </div>
                  <div className="row speakers_row">
                    <div className="col-xl-6 col-md-6">
                      <h4>Special Session Chair</h4>
                      <img
                        src={require("../assets/img-comm/bashir.jpg")}
                        alt="Dr Bashir Hayat"
                        width="200"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Bashir Hayat</b>
                        <br />
                        Institute of Management Sciences Peshawar, Pakistan
                      </p>
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <h4>Special Session Chair</h4>
                      <img
                        src={require("../assets/img-comm/Ryad.jpg")}
                        alt=""
                        width="230"
                        height="240"
                      />
                      <p className="organiser_intro  mt-2">
                        <b>Dr Ryad Soobhany</b>
                        <br /> Associate Professor, Heriot-Watt University,
                        Edinburgh|<b>Dubai</b>|Malaysia
                      </p>
                    </div>
                    {/* <div className="col-xl-4 col-md-4">
                      <h4>Special Session Chair</h4>
                      <img
                        src={require("../assets/img-comm/blank.png")}
                        alt="Dr Viloa"
                        width="200"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Viola Rühse</b>
                        <br />
                        Senior Researcher, University for Continuing Education
                        Krems, Austria
                      </p>
                    </div> */}

                    {/* <div className="col-xl-4 col-md-4">
                      <h4>Special Session Chair</h4>
                      <img
                        src={require("../assets/img-comm/qasem.png")}
                        alt="Dr Imad Rida "
                        width="220"
                        height="260"
                      />{" "}
                      <p className="organiser_intro  mt-2">
                        <b>Dr Qasem Abu Al-Haija </b>
                        <br />
                        Assistant Professor, Department of Cybersecurity, Jordan
                        University of Science and Technology, Irbid, Jordan
                      </p>
                    </div> */}
                  </div>

                  <div className="row speakers_row">
                    {/* <div className="col-xl-3 col-md-3">
                      <h4>Programme Committee Chair</h4>
                      <img
                        src={require("../assets/img-comm/bashir.jpg")}
                        alt="Dr Bashir Hayat "
                        width="230"
                        height="260"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Bashir Hayat</b>
                        <br />
                        Institute of Management Sciences Peshawar, Pakistan
                      </p>
                    </div> */}
                    {/* <div className="col-xl-4 col-md-4">
                      <h4>Programme Committee Chair</h4>
                      <img
                        src={require("../assets/img-comm/adrian.jpg")}
                        alt="Dr Adrian Turcanu"
                        width="200"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Adrian Turcanu</b>
                        <br /> Assistant Professor, Heriot-Watt University,
                        Edinburgh|<b>Dubai</b>|Malaysia
                      </p>
                    </div> */}
                    {/* <div className="col-xl-4 col-md-4">
                      <h4>Programme Committee Chair</h4>
                      <img
                        src={require("../assets/img-comm/blank.png")}
                        alt="Dr. Diego Oliva"
                        width="200"
                        height="270"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Dr Diego Oliva</b>
                        <br />
                        Associate Professor, University of Guadalajara,
                        Guadalajara, Jalisco, Mexico
                      </p>
                    </div> */}
                    <div className="col-xl-12 col-md-12">
                      <h4>Event Assitant</h4>
                      <img
                        src={require("../assets/img-comm/israr.png")}
                        alt="Israr Ahmad"
                        width="230"
                        height="250"
                      />{" "}
                      <p className="organiser_intro mt-2">
                        <b>Israr Ahmad</b>
                        <br />
                        Event Assistant, Dubai, United Arab Emirates
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Organizers;
